import Swiper, { Autoplay } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";


const swiperClientsOptions = {
  modules: [Autoplay],
  slidesPerView: "auto",
  loop: true,
  loopedSlides: 9,
  centerInsufficientSlides: true,
  speed: 3000,
  slidesPerGroup: 1,
};

if (!isAnimationStopped()) {
  swiperClientsOptions.autoplay = {
    delay: 10,
    disableOnInteraction: false,
    reverseDirection: true,
  };
}

const swiperClients = new Swiper(".clients-carousel__container", swiperClientsOptions);
